import { StateKey } from 'common/utils/flipState'
import HttpStatus from 'common/utils/httpStatus'
import logger from 'common/logger'
import { AdditionalPayInfo, WritableReviews } from 'common/types/entities/api/review'
import { fetchAdditionalInfoFromPay, fetchPagedMyWritableReviews } from 'common/services/review'

const initialState: WritableReviews = {
  writableReviews: [],
  page: 1,
  totalCount: 0,
}

const FETCH = 'my/review/FETCH'
const APPEND = 'my/review/APPEND'
const REGISTERED = 'my/review/REGISTERED'

export const fetchWritableReviews = (
  curState: StateKey,
  page: number,
  rowsPerPage: number,
  headers?: any,
  isAppend?: boolean,
) => async dispatch => {
  try {
    const params = {
      page,
      rowsPerPage,
    }
    const writableReviews = await fetchPagedMyWritableReviews(params, headers)
    if (writableReviews && writableReviews.totalCount > 0) {
      const productOrderNos: string[] = writableReviews.writableReviews.map(
        writableReview => writableReview.productOrderId,
      )
      const additionalPayInfo: AdditionalPayInfo = await fetchAdditionalInfoFromPay(
        productOrderNos.join(','),
        'REVIEW_BENEFITS',
      )
      additionalPayInfo &&
        writableReviews.writableReviews.forEach(writableReview => {
          writableReview.productOrderBenefitInfos =
            additionalPayInfo.productOrderBenefitInfos[writableReview.productOrderId]
        })
      dispatch({
        curState,
        page,
        ...writableReviews,
        type: isAppend ? APPEND : FETCH,
      })
    }
  } catch (err) {
    err && err.response && err.response.status && err.response.status !== HttpStatus.UNAUTHORIZED && logger.error(err)
    dispatch({
      curState,
      type: FETCH,
    })
  }
}

export const exceptRegisteredReviewFromList = (curState: StateKey, productOrderId: string) => async (
  dispatch,
  getState,
) => {
  const writableReviewsExceptRegistered = getState().writableReviews[curState].writableReviews.filter(
    writableReview => writableReview.productOrderId !== productOrderId,
  )
  const page = getState().writableReviews[curState].page
  dispatch({
    page,
    curState,
    writableReviewsExceptRegistered,
    type: REGISTERED,
  })
}

const myMyReviewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        writableReviews: action.writableReviews,
        page: action.page,
        totalCount: action.totalCount,
      }
    case APPEND:
      return {
        writableReviews: [...state.writableReviews, ...action.writableReviews],
        page: action.page,
        totalCount: action.totalCount,
      }
    case REGISTERED:
      return {
        writableReviews: action.writableReviewsExceptRegistered,
        totalCount: action.writableReviewsExceptRegistered && action.writableReviewsExceptRegistered.length,
        page: action.page,
      }

    default:
      return state
  }
}

export default myMyReviewsReducer
